import { MilestoneTodo } from "../hooks/useMilestones"

interface MilestoneTodoChecklistProps {
  todos?: MilestoneTodo[]
  /** 체크 토글 핸들러. 없으면 읽기 전용으로 표시 */
  onToggle?: (todoId: string) => void
  /** 저장 중일 때 입력 잠금 */
  saving?: boolean
  /** 칸반 카드처럼 좁은 영역용 축소 모드 */
  compact?: boolean
}

/**
 * 마일스톤 세부 To do 체크리스트 (읽기/토글 공용)
 * - 완료 항목은 취소선(strike) 처리
 * - onToggle 이 없으면 비활성 상태로만 표시
 */
export function MilestoneTodoChecklist({
  todos,
  onToggle,
  saving = false,
  compact = false,
}: MilestoneTodoChecklistProps) {
  const list = todos || []
  if (list.length === 0) return null

  const readOnly = !onToggle

  return (
    <ul className={compact ? "space-y-1" : "space-y-1.5"}>
      {list.map((todo) => {
        const done = Boolean(todo?.done)
        return (
          <li key={todo?.id}>
            <label
              onClick={(e) => e.stopPropagation()}
              className={`flex items-start gap-2 rounded-md px-1.5 py-1 transition-colors ${
                readOnly ? "cursor-default" : "cursor-pointer hover:bg-orange-50"
              } ${saving ? "opacity-60" : ""}`}
            >
              <input
                type="checkbox"
                checked={done}
                disabled={readOnly || saving}
                onClick={(e) => e.stopPropagation()}
                onChange={(e) => {
                  e.stopPropagation()
                  if (onToggle && todo?.id) onToggle(todo.id)
                }}
                className={`mt-0.5 shrink-0 rounded border-gray-300 text-orange-600 focus:ring-orange-500 ${
                  compact ? "w-3.5 h-3.5" : "w-4 h-4"
                }`}
              />
              <span
                className={`${compact ? "text-[11px] leading-snug" : "text-sm"} break-words ${
                  done ? "line-through text-gray-400" : "text-gray-700"
                }`}
                title={
                  done && todo?.doneByName
                    ? `${todo.doneByName} 완료`
                    : todo?.text || ""
                }
              >
                {todo?.text || ""}
              </span>
            </label>
          </li>
        )
      })}
    </ul>
  )
}
